const http = new XMLHttpRequest()

const returnError = (status, response) => {
  alert(`Error ${status}: ${response}`)
}

// HTTP GET REQUEST
export const get = (url, callback, headers = false) => {
  return new Promise((resolve, reject) => {
    http.open('GET', url, true)
    if (headers) {
      headers.forEach(header => {
        http.setRequestHeader(header.type, header.val)
      })
    }
    http.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    http.onload = () => {
      if (http.status >= 200 && http.status <= 299) {
        try {
          resolve(callback(JSON.parse(http.responseText)))
        } catch (e) {
          return false
        }
      } else {
        reject(returnError(http.status, http.responseText))
      }
    }
    http.send()
  })
}

// HTTP POST REQUEST
export const post = (url, data, callback, withContentType = false) => {
  http.open('POST', url, true)
  if (withContentType) {
    http.setRequestHeader('content-type', 'application/json')
    data = JSON.stringify(data)
  }
  http.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
  http.onload = () => {
    if (http.status >= 200 && http.status <= 299) {
      try {
        callback(JSON.parse(http.responseText))
      } catch (e) {
        return false
      }
    } else {
      returnError(http.status, http.responseText)
    }
  }
  http.send(data)
}

// HTTP POST REQUEST
export const upload = (url, file, callback, setProgressState) => {
  return new Promise((resolve, reject) => {
    http.open('POST', url, true)
    http.upload.onprogress = e => {
      setProgressState(Math.ceil((e.loaded / e.total) * 100))
    }
    http.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    http.onload = () => {
      if (http.status >= 200 && http.status <= 299) {
        try {
          resolve(callback(http.responseText))
        } catch (e) {
          return false
        }
      } else {
        reject(returnError(http.status, http.responseText))
      }
    }
    const data = new FormData()
    data.append('file', file)
    http.send(data)
  })
}

// HTTP PUT REQUEST
export const put = (url, data, callback) => {
  http.open('PUT', url, true)
  http.setRequestHeader('content-type', 'application/json')
  http.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
  http.onload = () => {
    if (http.status >= 200 && http.status <= 299) {
      try {
        callback(JSON.parse(http.responseText))
      } catch (e) {
        return false
      }
    } else {
      returnError(http.status, http.responseText)
    }
  }
  http.send(JSON.stringify(data))
}

// HTTP DELETE REQUEST
export const deleteRequest = (url, data, callback) => {
  http.open('DELETE', url, true)
  http.setRequestHeader('content-type', 'application/json')
  http.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
  http.onload = () => {
    if (http.status >= 200 && http.status <= 299) {
      try {
        callback(JSON.parse(http.responseText))
      } catch (e) {
        return false
      }
    } else {
      returnError(http.status, http.responseText)
    }
  }
  http.send(JSON.stringify(data))
}
